export function buildRailwayProviderOverrides(options: {
  databaseServiceName?: string
  buildCommand?: string
  bucketResourceName?: string
  bucketUrlStyle?: string
}): Record<string, string> {
  const overrides: Record<string, string> = {}
  if (options.databaseServiceName) {
    const resource = options.databaseServiceName
    overrides.DATABASE_URL = `\${{${resource}.DATABASE_URL}}`
    if (options.buildCommand?.trim()) {
      overrides.RAILPACK_BUILD_CMD = `DATABASE_URL='\${{${resource}.DATABASE_PUBLIC_URL}}' ${options.buildCommand}`
    }
  }
  if (options.bucketResourceName) {
    const resource = options.bucketResourceName
    Object.assign(overrides, {
      BETTERSTART_RAILWAY_BUCKET_ENDPOINT: `\${{${resource}.ENDPOINT}}`,
      BETTERSTART_RAILWAY_BUCKET_ACCESS_KEY_ID: `\${{${resource}.ACCESS_KEY_ID}}`,
      BETTERSTART_RAILWAY_BUCKET_SECRET_ACCESS_KEY: `\${{${resource}.SECRET_ACCESS_KEY}}`,
      BETTERSTART_RAILWAY_BUCKET_NAME: `\${{${resource}.BUCKET}}`,
      BETTERSTART_RAILWAY_BUCKET_REGION: `\${{${resource}.REGION}}`
    })
  }
  if (options.bucketUrlStyle) {
    overrides.BETTERSTART_RAILWAY_BUCKET_URL_STYLE = options.bucketUrlStyle
  }
  return overrides
}
